/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { useMemo } from 'react';
import { FederatedMFE } from '@pwc/pwc-deals-ui';
import { VersioningProps } from '../types';
import styles from '../Versioning.module.scss';

const VersioningMFE: React.FC<VersioningProps> = (props: VersioningProps) => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const {
    entityType,
    contentThreadId,
    projectId,
    handleVersionUpdate,
    selectedContentId,
    currentVersionId,
  } = props;
  const extraProps = useMemo(
    () => ({
      entityType,
      contentThreadId,
      projectId,
      isClient: !isPwcUser,
      selectedContentId,
      currentVersionId,
      handleVersionUpdate,
    }),
    [
      entityType,
      contentThreadId,
      projectId,
      selectedContentId,
      currentVersionId,
      handleVersionUpdate,
      isPwcUser,
    ]
  );

  return (
    <div className={styles['versioning--wrapper']}>
      <FederatedMFE
        url={String(process.env.REACT_APP_VERSIONING_MFE_URL)}
        scope="remoteapp"
        reducerModule="./VersioningReducers"
        componentModule="./Versioning"
        suspenseFallbackStyle={styles['versioning-loader-wrapper']}
        props={extraProps}
      />
    </div>
  );
};

export default VersioningMFE;
